import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const useURLFilters = (filters: string[]) => {
  const [searchParams] = useSearchParams();

  return React.useMemo(() => {
    if (filters.length) {
      return filters.reduce<Record<string, unknown>>((acc, key) => {
        const value = searchParams.get(key);
        if (value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {});
    }
    return Object.fromEntries(searchParams);
  }, [filters, searchParams]);
};
